import Client from 'shopify-buy';
//import { gsap } from 'gsap';
//import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
//import { debounce as _debounce } from 'underscore';
//import 'jquery-clickout';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el: 						false,
        	main: 						undefined,

        	debugBuyWindow : 			false,
        	debugCart : 				false,

        	// Crete a private APP (shopifyCtrl) on Shopify to access the token!
        	// https://shopify.dev/custom-storefronts/tools
        	// https://shopify.github.io/js-buy-sdk

			domain: 					'3d45e1-2.myshopify.com',
  			storefrontAccessToken: 		'9d4b4f623932e4e68df2bd0b0b3afbe9',

  			checkout_name_id: 			'HillArtFoundation-ShopifyCheckoutId'

        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'shopify';
		this.$el 			= 	this.options.$el;


		/*
		this.$buyButton 	= 	this.$el.find( '#buy-btn' );
		this.$cartButton 	= 	this.$el.find( '#cart-btn' );
		*/


		this.$buyWindow     =   $('#overlay-buy-window');


		this.main			=   this.options.main;
		this.$pageContainer = 	$('#smooth-scroll');
		this.$cart          =   $('#cart');

		this.$html 			=  $( 'html' );
		this.$window 		=  $(window);

		this.allProducts    = 	[];

		this.init();
		
    }

    init(){
    	//console.log( 'shopifyCtrl::Init' );
    	//this.addEvents( true );
    	this.initClient();
    	
	}


	initClient(){
		// Initializing a client to return content in the store's primary language
		const client = Client.buildClient({
		  	domain: 					this.options.domain,
		  	storefrontAccessToken: 	this.options.storefrontAccessToken
		});	
		this.client = client;

		if ( this.client ){
		}
	}

}
